export const getEmptyErrorMessage = (label?: string) =>
  `${label} cannot be empty.`;
